import { useGlobalStore } from '@/features/Global/store';

export const generateURL = (
  baseURL: string,
  path: string,
  ssl = true,
): string => {
  let protocol = '';

  if (baseURL.match(/http(s)?:\/\//i) === null) {
    protocol += ssl ? 'https://' : 'http://';
  }

  if (baseURL[baseURL.length - 1] === '/' || path[0] === '/') {
    return `${protocol}${baseURL}${path}`;
  }
  return `${protocol}${baseURL}/${path}`;
};

export const generateVglUrl = (path: string, sparte?: string): string => {
  const currentBasePath = import.meta.env.VITE_APP_BASE_URL || '/';

  return `${
    window.location.origin +
    currentBasePath +
    (sparte ?? useGlobalStore().getSparte)
  }/${path}`;
};
